// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1H1UA","colMin":"styles_colMin__3Ubl1","colCheckbox":"styles_colCheckbox__1HC75"};